module.exports = __webpack_public_path__ + "static/media/7_Confirm-Powered-Correctly-Blue.5c9660d3.svg";